<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Servicios" type="servicios" />
    <!-- End Breadcrump Area  -->

    <!-- Start Service Area  -->
    <div class="rn-service-area rn-section-gap bg_color--1">
      <v-container>
        <ServiceNotinList :Home="false" type="servicios"/>
      </v-container>
    </div>
    <!-- Start Service Area  -->
  </div>
</template>

<script setup lang="ts">
import feather from "feather-icons";
import { useStore } from '../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
const PageName = "Servicios"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
function iconSvg(icon) {
  return feather.icons[icon].toSvg();
}
</script>
